/**
 * @description 公共参数
 */

/* eslint-disable */

export const ballMap = {
  '-5': '受五球',
  '-4.75': '受五球/四球半',
  '-4.5': '受四球半',
  '-4.25': '受四球半/四球',
  '-4': '受四球',
  '-3.75': '受四球/三球半',
  '-3.5': '受三球半',
  '-3.25': '受三球半/三球',
  '-3': '受三球',
  '-2.75': '受三球/两球半',
  '-2.5': '受两球半',
  '-2.25': '受两球半/两球',
  '-2': '受两球',
  '-1.75': '受两球/一球半',
  '-1.5': '受一球半',
  '-1.25': '受一球半/一球',
  '-1': '受一球',
  '-0.75': '受一球/球半',
  '-0.5': '受半球',
  '-0.25': '受半球/平手',
  '0': '平手',
  '0.25': '平手/半球',
  '0.5': '半球',
  '0.75': '半球/一球',
  '1': '一球',
  '1.5': '一球/球半',
  '1.75': '球半/两球',
  '2': '两球',
  '2.25': '两球/两球半',
  '2.5': '两球半',
  '2.75': '两球半/三球',
  '3': '三球',
  '3.25': '三球/三球半',
  '3.5': '三球半',
  '3.75': '三球半/四球',
  '4': '四球',
  '4.25': '四球/四球半',
  '4.5': '四球半',
  '4.75': '四球半/五球',
  '5': '五球'
}

export const wxUrl = (appid, redirectUrl) => `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect`

export const bankList = [
  { label: '工商银行', value: 'ICBC' },
  { label: '农业银行', value: 'ABC' },
  { label: '中国银行', value: 'BOCSH' },
  { label: '建设银行', value: 'CCB' },
  { label: '招商银行', value: 'CMB' },
  { label: '浦发银行', value: 'SPDB' },
  { label: '广发银行', value: 'GDB' },
  { label: '交通银行', value: 'BOCOM' },
  { label: '邮政储蓄银行', value: 'PSBC' },
  { label: '中信银行', value: 'CNCB' },
  { label: '民生银行', value: 'CMBC' },
  { label: '光大银行', value: 'CEB' },
  { label: '华夏银行', value: 'HXB' },
  { label: '兴业银行', value: 'CIB' },
  { label: '平安银行', value: 'PAB' },
  { label: '北京银行', value: 'BCCB' },
  { label: '上海银行', value: 'BOS' },
]

export const ggName = [
  'GGPK',
  'GGPoker',
  'GG扑克',
  'GGPuke',
  'PKGG',
  'PukeGG',
  'PokerGG',
  '扑克GG',
  'GG撲克',
  'GG官方',
  'GG扑克官方',
  'GGPK官方',
  'GGPoker官方',
  'GG撲克官方',
  'GG客服',
  'GG',
  'gg',
  '扑克客服',
  '线上客服',
  '官方',
  '客服',
  '官方客服',
  '红龙',
  '扑克王',
  'Poker King',
  '部落先锋',
  '部落',
  'CPG',
  'service',
  'Poker',
  'poker',
  'Gg',
  'gG',
  '管理员',
  '管理者',
  '扑克之星',
  '6up',
  'GG客服',
  '撲克客服',
  '線上客服',
  '客服',
  '官方客服',
  '紅龍',
  '撲克王',
  '部落先鋒',
  '部落',
  '管理員',
  '管理者',
  '撲克之星',
  'GG客服',
  'natural8',
  'N8',
  'Natural8'
]
